module.exports = __webpack_public_path__ + "img/driving_preview-400x300.d574ad29.jpg";